import {Component, OnInit} from '@angular/core';
import {VisitaServices} from '../../services/visita.services';
import {PlantillaModel} from '../../models/plantilla.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {OPCCAT, OPCLOC, OPCNEG} from '../../../variables';
import {TiendaEntity} from '../../../CoreModule/entities/tienda.entity';
import * as lodash from 'lodash';
import {PlantillasServices} from '../../services/plantillas.services';

@Component({
  selector: 'visita-admin',
  templateUrl: '../../templates/admin/visitas.admin.template.html'
})
export class VisitaAdminComponent implements OnInit {

  lstTiendas: TiendaEntity[] = [];
  tiendasFilt: TiendaEntity[] = [];

  lstPlantillas: PlantillaModel[] = [];

  plantillaSelect: PlantillaModel;

  periodoVisitas:string = "";

  filtroLoc: string = '';
  filtroCat: string = '';
  filtroNeg: string = '';

  opcNegocio: string[] = OPCNEG;
  opcLocacion: string[] = OPCLOC;
  opcCategoria: string[] = OPCCAT;

  tiendasQuitar: any[] = [];

  constructor(private vs: VisitaServices, private ps: PlantillasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();

    this.vs.getInfoCrearVisitas().subscribe((d: any) => {
      this.lstPlantillas = d.data.plantillas.filter(p=> p.activo);


      this.lstTiendas = d.data.tiendas.filter(t => {
        return (t.activo == 1);
      });

      this.lstTiendas.sort((a:any, b:any)=>{
        if(a.nombre > b.nombre)
          return 1;
        else
          return -1;
      });

      this.tiendasFilt = this.lstTiendas;

      this.spinner.hide();
    });
  }

  crearVisitas() {

    if (this.tiendasFilt.length == 0) {
      alert('No hay ninguna tienda seleccionada');
      return;
    }

    let idPlan = this.plantillaSelect._id;
    let idsTiendas:string[] = [];

    this.tiendasFilt.map(t=>{
      idsTiendas.push(t.idDB);
    });

    this.spinner.show();
    this.vs.crearVisitas(idPlan,idsTiendas, this.periodoVisitas).subscribe(d=>{
      console.log(d);
      this.spinner.hide();
    })
  }

  filtrarTiendas() {
    this.tiendasFilt = lodash.clone(this.lstTiendas);

    if (this.filtroNeg != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.negocio == this.filtroNeg);

    if (this.filtroCat != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.categoria == this.filtroCat);

    if (this.filtroLoc != '') {
      this.tiendasFilt = this.tiendasFilt.filter(t => t.locacion == this.filtroLoc);
    }

    this.tiendasFilt.sort((a: any, b: any) => {
      if (a.nombre > b.nombre)
        return 1;
      else
        return -1;
    });

  }

  quitarTienda() {

    this.tiendasFilt = this.tiendasFilt.filter(t => {

      let found = this.tiendasQuitar.find(q => q == t.id);

      if (found)
        return false;
      else
        return true;
    });

    this.tiendasQuitar = [];
  }


}
